export default __webpack_public_path__ + "static/media/b05.184a69c7.jpg";